const colors = require('tailwindcss/colors')
const path = require('path');

module.exports = {
  purge: [
    './src/**/*.vue',
    path.resolve(__dirname, './node_modules/litepie-datepicker/**/*.js'),
  ],
  darkMode: false,
  theme: {
    fontSize: {
      'xxs': '.50rem',
      'xs': '.75rem',
      'sm': '.875rem',
      'slightly-sm': '.94rem',
      'lg': '1.125rem',
      'xl': '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '4rem',
      '7xl': '5rem',
    },
    extend: {
      spacing: {
        '22': '5.5rem'
      },
      height: {
        '34': '8.438rem',
        '26': '6.25rem',
        '90': '22rem',
      },
      width: {
        '26': '6.25rem',
        '90': '22rem',
      },
      fontFamily: {
        'qanelas': ['Qanelas Soft', 'Arial'],
      },
      colors: {
        'primary': '#11379d',
        'secondary': '#67c148',
        'primary-100': '#11379d',
        'primary-200': '#0f318d',
        'primary-300': '#0d2c7d',
        'primary-400': '#0b266d',
        'primary-500': '#0a215e',
        'primary-600': '#081b4e',
        'primary-700': '#06163e',
        'primary-800': '#05102f',
        'primary-900': '#030b1f',

        'background': '#FAFAFA',
        'test-mode': '#11379d',

        'error': '#C91C31',
        'success': '#55BE64',
        'bordercolor': '#D4D4D8',
        'hover-button': '#6cbe45',
        'click-button': '#11379d',

        'success-badge': "#F2FFF4",
        'error-badge': "#FFEEF0",
        'warning-badge': "#FFF2DD",
        'light-badge': "#F5F5F5",

        'white': colors.white,
        'blue': colors.blue,
        'gray': colors.gray,
        'yellow': colors.yellow,
        'red': colors.red,
        'bluelink': '#5c8de1',
        'divider-gray': '#E5E7EB',

        'approve': '#16A34A',
        'decline': '#B91C1C',

        'litepie-primary': {
          100: '#11379d',
          200: '#0f318d',
          300: '#0d2c7d',
          400: '#0b266d',
          500: '#0a215e',
          600: '#081b4e',
          700: '#06163e',
          800: '#05102f',
          900: '#030b1f',
        }, // color system for light mode
        'litepie-secondary': colors.gray // color system for dark mode
      },
      backgroundImage: theme => ({
        'app-logo': "",
      })
    },
  },
  variants: {
    extend: {
      opacity: ['disabled'],
      backgroundColor: ['active'],
      padding: ['hover'],
    },
  },
  plugins: [require('@tailwindcss/forms')],
}
